<csl-non-prod-banner [environment]="environment"></csl-non-prod-banner>
<div id="layout-container">

  @if (this.globalStore.progBarIsLoading()) {
    <p-progress-bar mode="indeterminate" [style]="{'height': '0.4em'}" color="#015989"></p-progress-bar>
  }
  @if (!this.globalStore.progBarIsLoading()) {
    <div class="progress-bar"></div>
  }

  <nav>
    <app-clinic-site-header></app-clinic-site-header>
  </nav>

  <app-health-record-breadcrumb> </app-health-record-breadcrumb>

  <div class="content">
    <aside>
      <ul>
        <li><a routerLinkActive="active-button" routerLink="documents"><i class="fa-solid fa-files fa-xl mr-2 opacity-80 min-w-5"></i>Documents</a></li>
        <li><a routerLinkActive="active-button" routerLink="lg"><i class="fa-solid fa-hands-holding-child fa-xl mr-2 opacity-80 min-w-5"></i>Legal Guardian</a></li>
        <li><a routerLinkActive="active-button" routerLink="details"><i class="fa-solid fa-memo-circle-info fa-xl mr-2 opacity-80 min-w-5"></i>Survivor Details</a></li>
      </ul>
    </aside>

    <div class="flex flex-col w-full">

      <main class="p-6">
        <router-outlet></router-outlet>
      </main>

    </div>

  </div>

  <app-clinic-site-footer></app-clinic-site-footer>

</div>

<div id="messages-toast" class="card flex justify-center">
  <p-toast />
</div>

<p-drawer id="helpDrawer" [visible]="showHelp()" position="bottom" [style]="{ 'height': 'auto', 'border-top-left-radius': '20px', 'border-top-right-radius': '20px'}" (onHide)="onHelpDrawerHide()">
  <div [innerHTML]="helpService.helpContent()"></div>
  <ng-template #header>
    <span class="font-semibold text-xl text-gray-500">{{helpService.helpTitle() ?? 'SurvivorLink Help'}}</span>
  </ng-template>
</p-drawer>
